//alert
let uAlert = {};
uAlert.opts = {};
uAlert.show_alert = function(options) {
    options = {
        isshow: true,
        title: options.title ? options.title : "提示",
        cont: options.cont,
        cancelauto: options.cancelauto ? options.cancelauto : false,
        life: options.life ? options.life : 10000,
        isCornerClose: options.isCornerClose ? options.isCornerClose : false,
        isclosebtn: options.isclosebtn ? options.isclosebtn : true,
        btntxt: options.btntxt ? options.btntxt : "确定",
        callback: options.callback ? options.callback : uAlert.close_alert,
        isCustomClose: options.isCustomClose ? options.isCustomClose : false,
        dialogType: options.dialogType ? options.dialogType : 1,
        btnSureTxt: options.btnSureTxt ? options.btnSureTxt : "确定",
        btnCancelTxt: options.btnCancelTxt ? options.btnCancelTxt : "取消",
        cancelCallback: options.cancelCallback ? options.cancelCallback : uAlert.close_alert,
        isSlot: options.isSlot ? options.isSlot : false,
        isOperation: options.isOperation ? options.isOperation : false,
        shareData: options.shareData ? options.shareData : {},
    }
    uAlert.opts = options;
    return options;
};
uAlert.close_alert = function() {
    uAlert.opts.isshow = false;
    return uAlert.opts;
};
// import Vue from 'vue'
export default {
    install(Vue) {
        Vue.prototype.$uAlert = uAlert;
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/dialog/alert.js